import store from '@/store';
import ManagerService from '@/api/ManagerService';

import {
  IRouterMiddleware,
  MiddlewareRoute,
  MiddlewareCallback
} from '../middleware.interface';
import { getPropsFromRoute } from '../router-utils';
import { OnboardingURL, getSignUpUrlRoutes } from '@/views/Onboarding/helpers';

const managerService = new ManagerService();

class InviteRedirect {
  constructor(
    private readonly to: MiddlewareRoute,
    private readonly from: MiddlewareRoute,
    private readonly next: MiddlewareCallback
  ) {}

  get flags() {
    return store.getters['flags/getFlags'] || [];
  }

  handleInviteOwner(params: any) {
    const route = getSignUpUrlRoutes() as typeof OnboardingURL;
    if (!params.isManagerRegistered) {
      return this.next({
        path: route.INVITATION_CREATE_ACCOUNT_OWNER,
        query: params
      });
    }

    return this.next({
      path: route.INVITATION_LOGIN_ACCOUNT_OWNER,
      query: params
    });
  }

  handleInvite() {
    (async () => {
      const inviteCode = this.to.params.code;
      const routerProps = getPropsFromRoute(this.to);
      const authState = routerProps.auth;

      managerService.disableInterception();

      try {
        const { data } = await managerService.checkInvite(inviteCode);
        const {
          inviteStatus,
          invitedMail,
          isManagerRegistered,
          business,
          inviter,
          isInvitedManager
        } = data;

        if (inviteStatus === 'accepted') {
          this.next('/');

          return;
        }

        const queryParams = {
          invitedBy: inviter.fullname,
          businessName: business.name,
          isInvitedManager,
          invitedMail,
          isManagerRegistered,
          inviteCode,
          authState
        };

        this.handleInviteOwner(queryParams);
      } catch (err) {
        this.next({ name: 'manager-invitation-not-found' });
      }
    })();
  }

  async execute() {
    this.handleInvite();
  }
}

export class HandleInviteRedirect implements IRouterMiddleware {
  canActivate(to: MiddlewareRoute): boolean {
    return (
      ['ownership-invitation', 'manager-invitation'].includes(to.name!) &&
      !!to.params.code
    );
  }

  async execute(
    to: MiddlewareRoute,
    from: MiddlewareRoute,
    next: MiddlewareCallback
  ): Promise<void> {
    const instance = new InviteRedirect(to, from, next);
    instance.execute();
  }
}
